module.exports = __webpack_public_path__ + "Roboto-Bold.eed9aab5449cc9c8430d.woff";


//////////////////
// WEBPACK FOOTER
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/node_modules/materialize-css/dist/fonts/roboto/Roboto-Bold.woff
// module id = ../../../../materialize-css/dist/fonts/roboto/Roboto-Bold.woff
// module chunks = vendor